import type { CSSProperties, ChangeEvent, HTMLAttributes, KeyboardEvent, RefCallback } from "react"

import type { ChangeHandler } from "react-hook-form"

import { ETypographySize } from "@/3514/components"
import type { TEmptyCallback } from "@/shared/types/functions"

enum EInputVariant {
    Whitish = "whitish",
    White = "white"
}

type TInputProps = {
    ref: RefCallback<HTMLInputElement>
    name: string
    label?: string
    type: "email" | "password" | "text"
    variant?: EInputVariant
    placeholder?: string
    textSize?: ETypographySize
    onClick?: TEmptyCallback
    onChange?(event?: ChangeEvent<HTMLInputElement>): void
    onKeyDown?(event?: KeyboardEvent): void
    onFocus?: ChangeHandler
    onBlur?: ChangeHandler
    wrapperClasses?: string
    inputClasses?: string
    iconType?: "lock"
    isDisabled?: boolean
    isRequired?: boolean
    isError?: boolean
    errorMessages?: string[]
    withSpelling?: boolean
    withSpellingCssOverride?: boolean
    mode?: Pick<HTMLAttributes<HTMLInputElement>, "inputMode">["inputMode"]
    autoComplete?: "off" | "on" | "email"
    maxSymbols?: number
    enterKeyHint?: Pick<HTMLAttributes<HTMLInputElement>, "enterKeyHint">["enterKeyHint"]
    wrapperDirection?: "row" | "column"
    inputHeight?: CSSProperties["height"]
    withErrorMessagesOffset?: boolean
    withTitles?: boolean
}

export { EInputVariant }
export type { TInputProps }
